<style lang="scss">

</style>
<template>
    <owl-carousel v-if="featured.length > 0" :items="1" :loop="true" :stage-padding="0" :margin="0" :nav="true" :autoplay="true" :nav-text="owlCarousel.featured.navText"
                    class="owl-carousel owl-theme owl-dots-sm owl-dots-bottom-left">
        <template slot="carousel-content">
            <PrimaryBeatCard v-for="beat in featured" :key="beat.id" :beat="beat" :image-size="600"></PrimaryBeatCard>
        </template>
    </owl-carousel>

    <div v-else class="text-center">
        <loading-icon></loading-icon>
    </div>
</template>

<script>
    import OwlCarousel from './../../../../marketplace/components/owlcarousel.vue'
    import BeatContainer from './../beatcontainer.vue'
    import LoadingIcon from './../loadingicon.vue'
    import Beat from './../../models/beat'
    import PrimaryBeatCard from "../next/PrimaryBeatCard";
	export default {
        props: ['pageId'],
	    created() {
            // this.getFeatured()
        },
        components: {
          PrimaryBeatCard,
	        BeatContainer, OwlCarousel, LoadingIcon
        },
        data() {
            return {
                owlCarousel: {
                    featured: {
                        navText: ['<i class="fal fa-chevron-left"></i>', '<i class="fal fa-chevron-right"></i>']
                    }
                },
                featured: [],
                music: [],
            }
        },
        computed: {
            page() {
                if (this.pageId) {
                    return this.config.getPageById(this.pageId)
                }
                return false
            },
            config() {
	            return this.$store.state.currentConfig
            },
            user() {
                return this.$store.state.user
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            playlistFeatured () {
                return this.$store.state.discoverPlaylist.primary
            }
        },
        methods: {
            getFeatured() {
                this.featured = []
                setTimeout(() => {
                    this.featured = this.playlistFeatured
                }, 1000)
            },
        },
        watch: {
            pageId(val) {
                if (val) {
                    this.getFeatured()
                }
            },
            'page.featured.primary.show': {
                handler(val) {
                    this.getFeatured();
                },
                immediate: true
            },
            'playlistFeatured': {
                handler(val) {
                    this.getFeatured();
                }
            },
            'page.page_full_width': {
                handler(val) {
                    // TEMP FIX to reload the owl carrousel when setting discover page to full width
                    this.getFeatured();
                }
            }
        }
	}
</script>
